
/* injects from baggage-loader */

import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouterLink} from 'react-router'

export default class Link extends React.Component {
  static propTypes = {
    to: PropTypes.string
  }

  render() {
    const {to} = this.props
    const isExternalLink = to && (to.startsWith('http') || to.startsWith('//'))

    if (isExternalLink) {
      return <a {...this.props} href={to} />
    } else if (to) {
      return <RouterLink activeClassName='is-active' {...this.props} />
    } else {
      return <span {...this.props} />
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/Link/index.js